import type { Transaction } from '@api/hooks/types/getTransactions';
import type { ColumnProps } from '@gurupay/gp-ui-library';
import { formatNumberAmount } from '@utils/utils';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { SignPaymentCellMobile } from '../components/SignPaymentCellMobile';

const mobileColumns: ColumnProps[] = [
	{ key: 'mobileOperation', label: '', align: 'left' },
];

const desktopRenders: Record<string, (row: Transaction) => ReactNode> = {
	beneficiary: ({ beneficiary }) => (
		<div className="flex flex-col">
			<span className="text-sm-bold text-neutral-950">{beneficiary.account_number}</span>
			<span className="text-sm-medium text-neutral-600">{beneficiary.name}</span>
		</div>
	),
	amount: ({ amount, currency }) => (
		<span className="text-sm-bold text-neutral-950">
			{formatNumberAmount(amount.toFixed(2))} {currency}
		</span>
	),
};

const mobileRenders = { mobileOperation: SignPaymentCellMobile };

export const useSignOperationsTable = () => {
	const isMobile = useMediaQuery({ query: '(max-width: 480px)' });
	const { t } = useTranslation('', { keyPrefix: 'signPayments' });

	const desktopColumns: ColumnProps[] = [
		{ key: 'beneficiary', label: t('table.beneficiary'), align: 'left', minWidth: 300 },
		{ key: 'document_number', label: t('table.docNo'), align: 'left', minWidth: 150 },
		{ key: 'execution_date', label: t('table.date'), align: 'left', minWidth: 180 },
		{ key: 'amount', label: t('table.amount'), align: 'right', minWidth: 160 },
	];

	return {
		columns: isMobile ? mobileColumns : desktopColumns,
		renders: isMobile ? mobileRenders : desktopRenders,
		showHeader: !isMobile,
	};
};
